import { memo } from 'react';

import { PauseIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

import { type FileStatusIconSize, fileStatusIcon, getFileStatusIconGlyphSize } from '../fileStatusIconSize';

export type FileStatusIconPausedProps = {
  size?: FileStatusIconSize;
};

export const FileStatusIconPaused = memo(({ size = 'default' }: FileStatusIconPausedProps) => {
  const { container } = fileStatusIcon({ size });
  const glyphSize = getFileStatusIconGlyphSize(size);

  return (
    <div
      aria-hidden
      className={cn('flex items-center justify-center rounded-full ads:bg-ads-amber-4 bg-amber-4', container())}
    >
      <PauseIcon className="ads:text-ads-amber-11 text-amber-11" size={glyphSize} />
    </div>
  );
});

FileStatusIconPaused.displayName = 'FileStatusIconPaused';
